export function commaOrAnyToStringArray(list, delimiter = ',') {
  if (Array.isArray(list)) {
    return list
      .filter((x) => x !== undefined && x !== null)
      .map(String)
      .map((e) => e.trim())
      .filter((x) => !!x);
  }

  if (typeof list === 'number') {
    return [String(list)];
  }

  if (typeof list === 'string') {
    // Split by delimiter while respecting escaped delimiters
    const placeholder = '\x00'; // Use null char as temporary placeholder

    return list
      .replace(new RegExp(`\\\\${escapeRegex(delimiter)}`, 'g'), placeholder)
      .split(delimiter)
      .map((e) => e.replace(new RegExp(placeholder, 'g'), delimiter).trim())
      .filter((x) => !!x);
  }

  return [];
}

function escapeRegex(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function combineAnyStringArray(s1, s2) {
  const c1 = commaOrAnyToStringArray(s1);
  const c2 = commaOrAnyToStringArray(s2);
  return [...new Set([...c1, ...c2])];
}
